export default "__VITE_ASSET__BbAVAPnb__"